import { Box } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";

import { usePclProductQuery } from "api/public/project/product/product.api";

import AmSection from "./components/AmSection";
import CertificationDateSection from "./components/CertificationDateSection";
import DocumentsSection from "./components/DocumentsSection";
import LabSection from "./components/LabSection";
import PpClaimSection from "./components/PpClaimSection";
import TechTypeSection from "./components/TechTypeSection";
import ValidationNumberSection from "./components/ValidationNumberSection";

const ProductSidebar = () => {
  const { id } = useParams();

  const { data: product } = usePclProductQuery(id ?? skipToken);

  if (!product) return;

  const { certification_date, tech_type, assigned_lab } = product;

  return (
    <Box bgcolor={"primary.main"} color={"primary.contrastText"} px={4}>
      <DocumentsSection />

      <CertificationDateSection certification_date={certification_date} />

      <AmSection />

      <ValidationNumberSection />

      <TechTypeSection techTypes={tech_type} />

      <PpClaimSection />

      <LabSection labName={assigned_lab.cctl_name} />
    </Box>
  );
};

export default ProductSidebar;
